// extracted by mini-css-extract-plugin
export default {"select":"Select_select__O3FlI","main":"Select_main__yOqk+","options":"Select_options__C1t0o"};